/* @flow */

import { combineReducers } from 'redux';

import appReducer from './appReducer';
import domainReducer from './domainReducer';
import uiReducer from './uiReducer';

// $FlowIssue
export default combineReducers({
  app: appReducer,
  domain: domainReducer,
  ui: uiReducer,
});
